export const apiToUiDuration: Record<string | number, string> = {
  ongoing: 'Ongoing',
  'until symptoms resolve': 'Until symptoms resolve',
  'as needed': 'As needed',
  7: 'For 1 week',
  14: 'For 2 weeks',
  21: 'For 3 weeks',

  30: 'For 1 month',
  60: 'For 2 months',
  90: 'For 3 months',
  180: 'For 6 months',
};

export const formatFullScriptDuration = (duration?: string | number | null) => {
  if (!duration) return;

  return apiToUiDuration[duration] || duration;
};
